import { LazoPaths } from "@/enums/LazoPaths";
import AuthService from "@/external/ensolvers-core-frontend-mui-v5/submodules/fox-typescript/services/AuthService";
import { useLogout } from "@/hooks/queries/auth/useAuthQueries";
import { useCallback, useEffect } from "react";
import { useNavigate } from "react-router-dom";

export const Logout = () => {
  const navigate = useNavigate();
  const { mutateAsync } = useLogout();

  const logout = useCallback(async () => {
    try {
      // Expire the HttpOnly .lazo.one cookie and revoke the token server-side.
      // The cookie is sent automatically; JS cannot clear it on its own.
      await mutateAsync();
    } catch {
      // Even if revocation fails, still clear the client and redirect so the
      // user is never left looking logged in.
    } finally {
      // logOut() first so its LOGOUT observer event fires while keys still exist.
      AuthService.logOut();
      // Full wipe — drops everything logOut() misses (e, tenant/workspace state,
      // signup forms, tour flags, sidebar).
      localStorage.clear();
      sessionStorage.clear();
      navigate(LazoPaths.INDEX);
    }
  }, [mutateAsync, navigate]);

  useEffect(() => {
    logout();
  }, [logout]);

  return <>Logout</>;
};
